export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13249.ee513f7f.jpg";